<ng-container *transloco="let t">
  @if (administrationUsers() | sort: usersAdminSortService.sortUserByState) {
    @let showDepartmentNames = canShowDepartmentNames();
    @let tableColumns = columns();
    <div appearance="outline" class="w-full gap-0! p-0! text-sm" tuiCardLarge>
      <ng-content select="[slot=header]" />
      @if (administrationUsers().length > 0) {
        <tui-scrollbar>
          <cdk-virtual-scroll-viewport
            #viewport
            class="tui-zero-scrollbar h-[58vh]"
            tuiScrollable
            [itemSize]="TABLE_ITEM_HEIGHT">
            <table class="w-full" tuiTable [columns]="tableColumns">
              <thead>
                <tr tuiThGroup>
                  <th
                    *tuiHead="'name'"
                    tuiTh
                    [sorter]="null"
                    [sticky]="true"
                    [style.top.px]="-viewport['_renderedContentOffset']">
                    {{ t('Nom et prénom') }}
                  </th>
                  <th
                    *tuiHead="'state'"
                    tuiTh
                    [sorter]="usersAdminSortService.sortUserByState"
                    [sticky]="true"
                    [style.top.px]="-viewport['_renderedContentOffset']">
                    {{ t('État') }}
                  </th>
                  @if (showDepartmentNames) {
                    <th
                      *tuiHead="'groups'"
                      tuiTh
                      [sorter]="null"
                      [sticky]="true"
                      [style.top.px]="-viewport['_renderedContentOffset']">
                      {{ t('Groupes actifs') }}
                    </th>
                  }
                  <th
                    *tuiHead="'admin'"
                    tuiTh
                    [sorter]="usersAdminSortService.sortUserByAdmin"
                    [sticky]="true"
                    [style.top.px]="-viewport['_renderedContentOffset']">
                    {{ t('Administrateur') }}
                  </th>
                  <th
                    *tuiHead="'actions'"
                    tuiTh
                    [sorter]="null"
                    [sticky]="true"
                    [style.top.px]="-viewport['_renderedContentOffset']">
                    {{ t('Actions') }}
                  </th>
                </tr>
              </thead>
              @let sortedUsers = administrationUsers() | tuiTableSort;
              <tbody tuiTbody [data]="sortedUsers">
                <tr
                  *cdkVirtualFor="let user of sortedUsers; trackBy: trackByUser"
                  class="group hover:bg-background-primary-hover"
                  tuiTr>
                  <td *tuiCell="'name'" class="min-w-72 max-w-72 p-3" tuiTd>
                    <pxc-user-card class="my-2" size="tiny" [mailAddress]="user.mailAddress" [user]="user" />
                  </td>
                  <td *tuiCell="'state'" class="min-w-48 max-w-48" tuiTd>
                    <pxc-user-admin-state-badge [state]="user.state" />
                  </td>
                  @if (showDepartmentNames) {
                    <td *tuiCell="'groups'" class="min-w-64 max-w-64" tuiTd>
                      <p class="text-text-secondary">
                        <tui-line-clamp
                          [content]="user.departmentNames?.join(', ') || t('Aucun groupe')"
                          [linesLimit]="2" />
                      </p>
                    </td>
                  }
                  <td *tuiCell="'admin'" class="min-w-48 max-w-48" tuiTd>
                    @if (user.state === UserAdminState.ENABLED) {
                      <input
                        size="m"
                        tuiSwitch
                        type="checkbox"
                        [ngModel]="user.isAdmin"
                        (ngModelChange)="adminChange(user)" />
                    }
                  </td>
                  <td *tuiCell="'actions'" class="min-w-48 max-w-48" tuiTd>
                    <pxc-action-buttons
                      [actionButtons]="actionButtonsByState()[user.state]"
                      [actions]="actionsByUserState()[user.state]"
                      [entity]="user" />
                  </td>
                </tr>
              </tbody>
            </table>
          </cdk-virtual-scroll-viewport>
        </tui-scrollbar>
      } @else {
        <pxc-empty-state class="my-8" [title]="t('Aucun utilisateur trouvé.')" />
      }
    </div>
  }
</ng-container>
